import WebViewer from '@pdftron/webviewer';
import * as Sentry from '@sentry/react';

import config from 'config/config';

const PDFTRON_INIT_PROMISE_KEY = '__finalcadPdftronInitPromise';
const PDFTRON_AREA_TAG = 'PDFTRON';

const isSentryEnabled = () =>
  config?.sentry?.environment !== 'localhost' && Boolean(config?.sentry?.dsn);

const sanitizeData = data => {
  if (!data) return {};

  const normalized = {};
  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === 'string') {
      normalized[key] = value.slice(0, 500);
      return;
    }
    if (value == null || typeof value === 'number' || typeof value === 'boolean') {
      normalized[key] = value;
      return;
    }
    normalized[key] = JSON.stringify(value).slice(0, 500);
  });

  return normalized;
};

export const reportPdftronException = (error, code, data = {}) => {
  const normalizedData = sanitizeData(data);
  if (!isSentryEnabled()) return;
  Sentry.captureException(error, {
    tags: {
      area: PDFTRON_AREA_TAG,
      code,
    },
    extra: normalizedData,
  });
};

export const ensurePdftronInitialized = () => {
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.Core) return Promise.resolve(window.Core);

  if (!window[PDFTRON_INIT_PROMISE_KEY]) {
    const bootstrapEl = document.createElement('div');
    bootstrapEl.style.cssText =
      'position:absolute;width:0;height:0;visibility:hidden;pointer-events:none;';
    document.body.appendChild(bootstrapEl);

    window[PDFTRON_INIT_PROMISE_KEY] = WebViewer(
      {
        path: '/webviewer',
        licenseKey: config.pdfTronLicenseKey,
        // headless / Core-only init
        backendType: 'ems',
      },
      bootstrapEl,
    )
      .then(() => {
        // window.Core est maintenant disponible
        if (window.Core?.setWorkerPath) {
          window.Core.setWorkerPath('/webviewer/core');
        }
        return window.Core;
      })
      .catch(err => {
        window[PDFTRON_INIT_PROMISE_KEY] = null;
        reportPdftronException(err, 'ENSURE_INIT_FAILED', { path: window.location?.pathname });
        throw err;
      });
  }
  return window[PDFTRON_INIT_PROMISE_KEY];
};
